import { pipe } from 'lib/pipe.js';
import * as actions from 'store/actions/actions.js';
import {
  debounceTime,
  distinctUntilChanged,
  fromEventPattern,
  map,
  scan,
} from 'rxjs';

export default function setupHostAppListeners(
  hostAppGate,
  { store, events$, hostAction$ },
) {
  hostAppGate.onStart = (message) => {
    store.dispatch(actions.interactiveStart(message));

    events$.next({
      topic: '/host-action',
      payload: {
        cmd: 'start', // may use actions.interactiveStart.type ?,
        type: 'video',
        data: message,
      },
    });
  };
  hostAppGate.onStop = (message) => {
    store.dispatch(actions.interactiveStop(message));

    events$.next({
      topic: '/host-action',
      payload: {
        cmd: 'stop',
        type: 'video',
      },
    });
  };
  hostAppGate.onAction = hostAction$.next.bind(hostAction$);

  fromEventPattern(
    (handler) => (hostAppGate.onTimeUpdate = handler),
    () => (hostAppGate.onTimeUpdate = null),
  )
    .pipe(
      // too many updates on iOS during seek
      debounceTime(500),
      map((message) => {
        // rude patch for RMI-939,
        // TODO: resole getting live VOD position problem:
        //  STV - completely out of work,
        //  the site has the same ugly solution
        if (message.content_type === 'live') {
          message.position = Math.round(Date.now() / 1e3);
        }
        return message;
      }),
      distinctUntilChanged((prev, next) => prev.position === next.position),
      scan((prev, message) => {
        return {
          ...message,
          position_delta: message.position - prev.position,
        };
      }),
    )
    .subscribe((message) => {
      events$.next({
        topic: '/host-action',
        payload: {
          cmd: 'update',
          type: 'video-position',
          data: message,
        },
      });
      /*
TODO: Disable that action when all time related changes migrated to components
    e.g. emoji.displayQueue, extending every other actions with current time, etc.
    Also: replace store listener updateTimer action
    Also: move 01-app middleware logic into timeService
 */
      store.dispatch(actions.updateTimer(message));
    });

  hostAppGate.onZoneResize = pipe(actions.interactiveResize, store.dispatch);
  hostAppGate.onPause = pipe(actions.interactivePause, store.dispatch);
  hostAppGate.onResume = pipe(actions.interactiveResume, store.dispatch);
}
